import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import * as model from '../../../models';
import { Store } from "@ngrx/store";
import { Subscription } from 'rxjs/Rx';
import { AccessCodesApi } from "../../../services"
import { AppState } from "../../../reducers";
import { MessageActions } from '../../../actions';
import { ErrorHandlerService } from '../../../services';
import { Counts } from "../../../services/webservice/access-codes-api.service";

@Component({
	selector: 'access-codes-component',
	template: `
		<access-codes-presentation
				(cancelClicked)="hideAccessCodesPopup()"
				(generateCodesClicked)="generateCodes($event)"
				(downloadCodesClicked)="downloadCodes($event)"
				[counts]="counts"
				[showAccessCodesPopup]="showAccessCodesPopup"
		></access-codes-presentation>`,
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class AccessCodesComponent {
	@Input() showAccessCodesPopup: boolean;
	@Input() priceLevelUuid: string;
	@Output() hideAccessCodesPopupClicked = new EventEmitter<void>();

	counts: Counts = {
		count: 0,
		redeemed: 0,
		unused: 0,
	}

	private eventUuid: string;
	private subscription: Subscription;

	constructor(
		private store: Store<AppState>,
		private accessCodesApi: AccessCodesApi,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService,
		private changeDetectorRef: ChangeDetectorRef
	) {
	}

	ngOnInit() {
		this.subscription = this.store.select("eventServerState", "event", "currentEvent").subscribe((event: model.Event) => {
			if (!event) return;
			this.eventUuid = event.uuid;
		})
		this.loadCounts();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	generateCodes(amount: number) {
		this.accessCodesApi.generateAccessCodes(this.eventUuid, this.priceLevelUuid, amount).subscribe(
			(counts) => {
				this.counts = counts;
				this.changeDetectorRef.markForCheck();
				this.store.dispatch(this.messageActions.displayMessage('Die Zugangscodes wurden generiert.', 'success'));
			}, error => {
				const errorMessage = this.errorHandler.getErrorMessage(error, "Die Zugangscodes konnten nicht generiert werden.");
				this.store.dispatch(this.messageActions.displayMessage(errorMessage, "error"));
			}
		)
	}

	downloadCodes(filter: string) {
		this.accessCodesApi.downloadCodes(this.priceLevelUuid, filter).subscribe(
			() => {
				this.store.dispatch(this.messageActions.displayMessage('Die Zugangscodes wurden heruntergeladen.', 'success'));
			}, error => {
				const errorMessage = this.errorHandler.getErrorMessage(error, "Die Zugangscodes konnten nicht heruntergeladen werden.");
				this.store.dispatch(this.messageActions.displayMessage(errorMessage, "error"));
			}
		)
	}

	hideAccessCodesPopup() {
		this.hideAccessCodesPopupClicked.emit();
	}

	private loadCounts() {
		this.accessCodesApi.loadCounts(this.priceLevelUuid).subscribe(
			(counts) => {
				this.counts = counts;
				this.changeDetectorRef.markForCheck();
			}, error => {
				const errorMessage = this.errorHandler.getErrorMessage(error, "Die Anzahl von Zugangscodes konnte nicht geladen werden.");
				this.store.dispatch(this.messageActions.displayMessage(errorMessage, "error"));
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/price-form/access-codes/access-codes.component.ts